import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeft, Printer } from 'lucide-react';
import { useDatos } from '../contexts/DatosContext';
import { Boton } from '../components/ui/Boton';
import { PIE_IMPRESION } from '../data/textos';
import { formatearFecha, minutosPlanificados } from '../utils/clase';
import { calcularAdvertencias } from '../utils/reglas';
import { CHECKS_LOGISTICA } from '../data/constantes';
export function Impresion() {
  const {
    id
  } = useParams();
  const navegar = useNavigate();
  const {
    clases,
    recursos
  } = useDatos();
  const clase = clases.find(c => c.id === id);
  if (!clase) {
    return <div className="min-h-screen bg-lienzo px-4 py-10" data-id="element-528" data-mp="3nvt7orey11ie">
        <div className="mx-auto max-w-xl rounded-2xl border border-linea bg-white p-6" data-id="element-529" data-mp="3ix9navfzzxs5">
          <h1 className="text-lg font-bold text-tinta-titulo" data-id="element-530" data-mp="3dxwyi55kggmx">No encontramos esa clase</h1>
          <p className="mt-2 text-sm text-tinta-sec" data-id="element-531" data-mp="38ykahh2yl3ir">
            Puede que se haya eliminado o que el enlace no corresponda a este dispositivo.
          </p>
          <Boton className="mt-4" onClick={() => navegar('/clases')} data-id="element-532" data-mp="38q3ot3p7tlyx">
            Volver a Mis clases
          </Boton>
        </div>
      </div>;
  }
  const advertencias = calcularAdvertencias(clase, recursos);
  const objetivo = clase.objetivo === 'Personalizado' ? clase.objetivoPersonalizado || 'Personalizado' : clase.objetivo;
  return <div className="min-h-screen bg-lienzo" data-id="element-533" data-mp="3rhczhgaq2gs3">
      <div className="no-imprimir sticky top-0 z-10 border-b border-linea bg-white" data-id="element-534" data-mp="3rio39g463oj7">
        <div className="mx-auto flex max-w-4xl flex-wrap items-center justify-between gap-2 px-4 py-3" data-id="element-535" data-mp="b39lab2q7sm">
          <Boton variante="contorno" onClick={() => navegar(-1)} data-id="element-536" data-mp="3hj74zjr8wcx9">
            <ArrowLeft className="h-4 w-4" aria-hidden="true" data-id="element-537" data-mp="3mi0g55j27ru9" />
            Volver
          </Boton>
          <Boton onClick={() => window.print()} data-id="element-538" data-mp="264a7rmkwqhet">
            <Printer className="h-4 w-4" aria-hidden="true" data-id="element-539" data-mp="266o19qzxvlk9" />
            Imprimir / Guardar como PDF
          </Boton>
        </div>
      </div>

      <main className="mx-auto max-w-4xl px-4 py-6" data-id="element-540" data-mp="hl77kekati6a">
        <article className="hoja-a4 mx-auto w-full max-w-[210mm] bg-white p-8 text-[12px] leading-snug text-black shadow-[0_1px_3px_rgba(17,24,39,0.1)]" data-id="element-541" data-mp="hn0hc2q7kiii">
          <header className="evitar-corte border-b border-black/30 pb-3" data-id="element-542" data-mp="7u2sleumhxbg">
            <p className="text-[11px] font-bold uppercase tracking-wide" data-id="element-543" data-mp="2wjeqg1u7mk1">
              Planificador Pro de Clases de Telas
            </p>
            <h1 className="mt-1 text-[20px] font-bold" data-id="element-544" data-mp="3u3vxv0ma6a2l">{clase.titulo || 'Clase sin título'}</h1>
            <p className="mt-1 text-[11px]" data-id="element-545" data-mp="3pzxtobi3m92o">
              Fecha: {formatearFecha(clase.fecha)} · Grupo: {clase.grupo || '—'} · Estado:{' '}
              {clase.estado}
            </p>
          </header>

          <section className="evitar-corte mt-4" data-id="element-546" data-mp="3g44dmi567xg5">
            <h2 className="text-[13px] font-bold uppercase tracking-wide" data-id="element-547" data-mp="1ja15xuwu35ih">Datos del grupo</h2>
            <table className="mt-2 w-full border-collapse text-[11px]" data-id="element-548" data-mp="1ebg5pvhl0lu1">
              <tbody data-id="element-549" data-mp="1e93ndh7ww9gg">
                <Fila celdas={[['Población', clase.poblacion], ['Nivel', clase.nivel], ['Autonomía', clase.autonomia]]} data-id="element-550" data-mp="1luz69fmvcxqd" />
                <Fila celdas={[['Participantes', String(clase.participantes)], ['Telas o puntos', String(clase.puntos)], ['Duración', `${clase.duracion} min`]]} data-id="element-551" data-mp="1vlk2wxizfs6n" />
                <Fila celdas={[['Tipo', clase.tipo], ['Altura', clase.altura], ['Objetivo', objetivo]]} data-id="element-552" data-mp="17uenukkv93xe" />
              </tbody>
            </table>
            {clase.consideraciones && <p className="mt-2 text-[11px]" data-id="element-553" data-mp="2o9pqds1f7va6">
                <span className="font-bold" data-id="element-554" data-mp="2o8wr1c4sk822">Consideraciones: </span>
                {clase.consideraciones}
              </p>}
          </section>

          <section className="evitar-corte mt-4" data-id="element-555" data-mp="2qsugxoljqn5u">
            <h2 className="text-[13px] font-bold uppercase tracking-wide" data-id="element-556" data-mp="2qvp25icdwc0b">Logística</h2>
            <p className="mt-1 text-[11px]" data-id="element-557" data-mp="2mtty4632jkiu">
              Estrategia: {clase.logistica.estrategia} · Profes o asistentes:{' '}
              {clase.logistica.profes}
            </p>
            {clase.logistica.nota && <p className="text-[11px]" data-id="element-558" data-mp="2vus6f0kjie78">Nota: {clase.logistica.nota}</p>}
            <ul className="mt-1 text-[11px]" data-id="element-559" data-mp="39r5ks0ts1zhh">
              {CHECKS_LOGISTICA.map(c => <li key={c.id} data-id="element-560" data-mp="35q3nhpjf7xi5">
                  [{clase.logistica.checks[c.id] ? 'X' : ' '}] {c.texto}
                </li>)}
            </ul>
          </section>

          <section className="mt-4" data-id="element-561" data-mp="3eix2rmyvaww0">
            <h2 className="text-[13px] font-bold uppercase tracking-wide" data-id="element-562" data-mp="3ejyrgu8t3hw7">
              Bloques ({minutosPlanificados(clase)} min planificados de {clase.duracion} min)
            </h2>
            {clase.bloques.map(b => <div key={b.uid} className="evitar-corte mt-3 border-t border-black/20 pt-2" data-id="element-563" data-mp="bxsdmem7pqq5">
                <div className="flex items-baseline justify-between" data-id="element-564" data-mp="bvxrwy349ul0">
                  <h3 className="text-[12px] font-bold" data-id="element-565" data-mp="fyu4a722cugi">{b.nombre}</h3>
                  <span className="text-[11px]" data-id="element-566" data-mp="20dzilnrhe10">{b.minutos} min</span>
                </div>
                {b.objetivo && <p className="text-[11px] italic" data-id="element-567" data-mp="6xmj8qok5q4d">{b.objetivo}</p>}
                {b.notas && <p className="text-[11px]" data-id="element-568" data-mp="3oenigf8x9tue">{b.notas}</p>}
                {b.ejercicios.length === 0 ? <p className="text-[11px]" data-id="element-569" data-mp="3t65k75irrygf">Sin ejercicios asignados.</p> : <table className="mt-1 w-full border-collapse text-[11px]" data-id="element-570" data-mp="3ffa7tj92az83">
                    <thead data-id="element-571" data-mp="3kdc2l1fuomze">
                      <tr className="border-b border-black/20 text-left" data-id="element-572" data-mp="3ken5z05dvspz">
                        <th className="py-1 pr-2 font-bold" data-id="element-573" data-mp="35gl2sr29l999">Ejercicio</th>
                        <th className="py-1 pr-2 font-bold" data-id="element-574" data-mp="35innqwok8c74">Min</th>
                        <th className="py-1 pr-2 font-bold" data-id="element-575" data-mp="3aewaav5377ob">Variante</th>
                        <th className="py-1 pr-2 font-bold" data-id="element-576" data-mp="2rb14r4j9lk12">Lado</th>
                        <th className="py-1 pr-2 font-bold" data-id="element-577" data-mp="2mk2pm8a0irze">Modalidad</th>
                        <th className="py-1 font-bold" data-id="element-578" data-mp="2mirh5v5mgw1y">Indicaciones</th>
                      </tr>
                    </thead>
                    <tbody data-id="element-579" data-mp="2clwp9v3uttwn">
                      {b.ejercicios.map(e => <tr key={e.uid} className="border-b border-black/10 align-top" data-id="element-580" data-mp="2cjsbmlg5lgj6">
                          <td className="py-1 pr-2" data-id="element-581" data-mp="3a8vlk4qmwzu0">{e.nombre}</td>
                          <td className="py-1 pr-2" data-id="element-582" data-mp="35blrgbsavzzu">{e.minutos}</td>
                          <td className="py-1 pr-2" data-id="element-583" data-mp="30b7fiinkw5wj">{e.variacion}</td>
                          <td className="py-1 pr-2" data-id="element-584" data-mp="30dk61k7ejol7">{e.lado}</td>
                          <td className="py-1 pr-2" data-id="element-585" data-mp="2vbl2oabnwro9">{e.modalidad}</td>
                          <td className="py-1" data-id="element-586" data-mp="1owtvjovy4als">
                            {[e.seriesRepes, e.notas].filter(Boolean).join(' · ') || '—'}
                          </td>
                        </tr>)}
                    </tbody>
                  </table>}
              </div>)}
          </section>

          {clase.recordatorio && <section className="evitar-corte mt-4 border border-black/30 p-2" data-id="element-587" data-mp="9dcrtu9aslmw">
              <h2 className="text-[12px] font-bold uppercase tracking-wide" data-id="element-588" data-mp="9b9s2iicfe4z">Recordatorio</h2>
              <p className="text-[11px]" data-id="element-589" data-mp="e5e1r9izu09r">{clase.recordatorio}</p>
            </section>}

          {advertencias.length > 0 && <section className="evitar-corte mt-4" data-id="element-590" data-mp="n4hnkl9jotry">
              <h2 className="text-[13px] font-bold uppercase tracking-wide" data-id="element-591" data-mp="n2y46lsle2ly">Advertencias</h2>
              <ul className="mt-1 list-inside list-disc text-[11px]" data-id="element-592" data-mp="s4dogbmy453a">
                {advertencias.map(a => <li key={a.id} data-id="element-593" data-mp="x0unw1zli5vo">
                    <span className="font-bold" data-id="element-594" data-mp="2tvh3re7s67u6">{a.titulo}:</span> {a.detalle}
                  </li>)}
              </ul>
            </section>}

          <section className="evitar-corte mt-4" data-id="element-595" data-mp="2ywekdmd56ttk">
            <h2 className="text-[13px] font-bold uppercase tracking-wide" data-id="element-596" data-mp="14lepcxs6pnw0">Evaluación posterior</h2>
            {clase.evaluacion ? <ul className="mt-1 text-[11px]" data-id="element-597" data-mp="zn3hutpd3pgy">
                <li data-id="element-598" data-mp="1ecsupm6thhx2">Resultado: {clase.evaluacion.resultado}</li>
                <li data-id="element-599" data-mp="1ee401qfwuxqa">Qué funcionó bien: {clase.evaluacion.funciono || '—'}</li>
                <li data-id="element-600" data-mp="19dyf0t45c9h6">Qué presentó dificultad: {clase.evaluacion.dificultad || '—'}</li>
                <li data-id="element-601" data-mp="lodlxhea3vu6">Adaptaciones utilizadas: {clase.evaluacion.adaptaciones || '—'}</li>
                <li data-id="element-602" data-mp="gpkfua1bn741">Qué conviene repetir: {clase.evaluacion.repetir || '—'}</li>
                <li data-id="element-603" data-mp="vmb901kejml7">Próximo objetivo: {clase.evaluacion.proximoObjetivo || '—'}</li>
                <li data-id="element-604" data-mp="qmyklcdvu7gi">Observaciones: {clase.evaluacion.observaciones || '—'}</li>
              </ul> : <div className="mt-1 space-y-3 text-[11px]" data-id="element-605" data-mp="270f79jy0vww2">
                {['Qué funcionó bien', 'Qué presentó dificultad', 'Adaptaciones utilizadas', 'Qué conviene repetir', 'Próximo objetivo'].map(t => <div key={t} data-id="element-606" data-mp="2el930fiow87w">
                    <p className="font-bold" data-id="element-607" data-mp="2eid68uikvpl1">{t}</p>
                    <div className="mt-3 border-b border-black/30" data-id="element-608" data-mp="20lgi50tugm7u" />
                  </div>)}
              </div>}
          </section>

          <footer className="mt-6 border-t border-black/30 pt-2 text-[10px]" data-id="element-609" data-mp="2sbuo8avm8u8y">
            {PIE_IMPRESION}
          </footer>
        </article>
      </main>
    </div>;
}
function Fila({
  celdas
}: {
  celdas: [string, string][];
}) {
  return <tr className="border-b border-black/10" data-id="element-610" data-mp="2jihnwnv82qcu">
      {celdas.map(([t, v]) => <td key={t} className="py-1 pr-3 align-top" data-id="element-611" data-mp="2nkmcv9aq6yt5">
          <span className="font-bold" data-id="element-612" data-mp="2njb8b79ghn0z">{t}: </span>
          {v}
        </td>)}
    </tr>;
}